'use strict';

module.exports = {
  __init__: [ 'popupMenu' ],
  popupMenu: [ 'type', require(146) ]
};
